import { Badge, Card, CardContent, View, Image } from "@/components/ui";
import { useAuthState } from "@/store/auth";
import { Typography } from "@/components/shared/typography";
import UserIcon from "@/assets/images/3d-icons/user.png";

export const AccountProfileOverview = () => {
  const {
    data: { userInfo },
  } = useAuthState();
  return (
    <Card shadow="sm">
      <CardContent className="flex flex-row items-center gap-3 p-3">
        <View className="flex flex-row items-center gap-2">
          <Image src={UserIcon} width={24} height={24} />
        </View>
        <View className="flex flex-1 flex-row items-center justify-between">
          <Typography variant="label-sm">{userInfo.name}</Typography>
          <Badge variant="info" size="sm" outline={false}>
            <Typography
              variant="body-sm"
              className="font-medium text-info-on-surface"
            >
              {userInfo.accountType}
            </Typography>
          </Badge>
        </View>
      </CardContent>
    </Card>
  );
};
